import React from 'react';
import { Box, Container, Typography, Link, Stack, Slide } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const Footer = ({ showFooter }) => {
  return (
    <Slide direction="up" in={showFooter} mountOnEnter unmountOnExit>
      <Box
        component="footer"
        sx={{
          bgcolor: 'background.paper',
          borderTop: '1px solid',
          borderColor: 'divider',
          mt: 'auto',
          py: { xs: 3, sm: 4 },
          px: { xs: 2, sm: 3 },
        }}
      >
        <Container maxWidth="lg">
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            <Typography variant="body2" color="text.secondary">
              © {new Date().getFullYear()} Candidate Tools. All Rights Reserved.
            </Typography>
            <Stack direction="row" spacing={3}>
              <Link
                component={RouterLink}
                to="/help"
                variant="body2"
                color="text.secondary"
                underline="hover"
              >
                Help
              </Link>
              <Link
                component={RouterLink}
                to="/privacy" // Points to your existing legal page
                variant="body2"
                color="text.secondary"
                underline="hover"
              >
                Privacy
              </Link>
              <Link
                component={RouterLink}
                to="/terms" // Points to your existing legal page
                variant="body2"
                color="text.secondary"
                underline="hover"
              >
                Terms
              </Link>
            </Stack>
          </Stack>
        </Container>
      </Box>
    </Slide>
  );
};

export default Footer;